import { ExpiringAggregateReadyCollection } from 'src/util/collection/ExpiringAggregateReadyCollection';

export default (function () {
	const instance: ExpiringAggregateReadyCollection = new ExpiringAggregateReadyCollection();

	return () => {
		return instance;
	};
})();
